import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-钻井跟踪_控压监测",
  "use": "icon-钻井跟踪_控压监测-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-钻井跟踪_控压监测\">\n<g>\n\t<polygon points=\"16,15.7 0,15.7 0,0.3 1.1,0.3 1.1,14.7 16,14.7 \t\" />\n</g>\n<g>\n\t<polygon points=\"9.7,12 6.5,5.4 4.3,9.5 0.5,9.5 0.5,8.5 3.7,8.5 6.6,3.2 9.7,9.7 12.1,4.8 15.9,4.8 15.9,5.8 12.7,5.8 \t\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol